/**
 * Fund Cards Grid — filtro + paginação "ver mais"
 * Liga os selects/busca do fund-filter à grid de fund-cards, filtrando por
 * categoria (fundo_estrategia), objetivo (fundo_classe) e nome do fundo.
 * Se a grid tiver data-per-page, exibe só os N primeiros cards que batem com
 * o filtro atual e revela mais a cada clique no botão "ver mais"; qualquer
 * mudança de filtro (inclusive reset para "todos") volta a paginação para N.
 */
import AOS from 'aos';

export function initFundCardsGridFilter() {
  const grid = document.querySelector('.fund-cards-grid');
  if (!grid) return;

  const filterBar = document.querySelector('.fund-filter');
  const cards = Array.from(grid.querySelectorAll('.fund-card'));
  const vazioEl = grid.querySelector('.fund-cards-grid__vazio');
  const btnVerMais = grid.querySelector('.fund-cards-grid__btn-ver-mais');
  const perPage = parseInt(grid.dataset.perPage, 10) || 0;

  const state = { categoria: '', objetivo: '', busca: '' };
  let visibleLimit = perPage || Infinity;

  function matchesFiltro(card) {
    const matchCategoria = !state.categoria ||
      !!card.querySelector(`.fund-card__tag[data-campo="fundo_estrategia"][data-valor="${state.categoria}"]`);
    // Lê a classe do atributo do card, não da tag: a tag pode estar exibindo o
    // Objetivo (campo "O que exibir na tag?") e aí não traz a classe.
    const matchObjetivo = !state.objetivo || card.dataset.classe === state.objetivo;
    const matchBusca = !state.busca || (card.dataset.nome || '').includes(state.busca);
    return matchCategoria && matchObjetivo && matchBusca;
  }

  function render() {
    let encontrados = 0;
    let visiveis = 0;

    cards.forEach(card => {
      if (!matchesFiltro(card)) {
        card.hidden = true;
        return;
      }
      encontrados++;
      const visivel = encontrados <= visibleLimit;
      card.hidden = !visivel;
      if (visivel) visiveis++;
    });

    if (vazioEl) vazioEl.hidden = visiveis > 0;
    if (btnVerMais) btnVerMais.hidden = encontrados <= visibleLimit;

    // Mostrar/ocultar cards muda a altura da página; sem isso, o AOS mantém
    // o offset calculado no load e a animação de seções abaixo (ex.: FAQ)
    // só dispara quando a altura real volta a bater com aquele offset antigo.
    AOS.refresh();
  }

  function filterCards() {
    visibleLimit = perPage || Infinity;
    render();
  }

  render();

  if (btnVerMais) {
    btnVerMais.addEventListener('click', () => {
      visibleLimit += perPage;
      render();
    });
  }

  if (filterBar) {
    filterBar.addEventListener('fund-filter:change', (e) => {
      const chave = e.target?.dataset?.filter;
      if (!chave || !(chave in state)) return;
      const valor = e.detail?.value || '';
      state[chave] = valor === 'todos' ? '' : valor;
      filterCards();
    });

    const searchInput = filterBar.querySelector('.fund-filter__input[data-filter="busca"]');
    if (searchInput) {
      searchInput.addEventListener('input', () => {
        state.busca = searchInput.value.trim().toLowerCase();
        filterCards();
      });
    }
  }
}
